angular.module('FlexyBeautyApp.services')
    .factory('BookingStatus',function () {
        let bookingStatus = {
            WAITING_FOR_CONFIRM : "waitingForConfirm",
            CREATED : "created",
            PLANNED : "planned",
            NOT_CAME : "notCame",
            CAME : "came",
            PAYED : "payed",
            PREPAID : "prepaid"
        };
        return bookingStatus;
    });



// WEBPACK FOOTER //
// ./js/services/views/ConstantsBookingStatus.js